import { articles, type Article } from "@/mocks/articles";

export const formatDate = (iso: string): string => {
  const parts = iso.split("-");
  if (parts.length !== 3) return iso;
  return `${parts[0]}年${Number(parts[1])}月${Number(parts[2])}日`;
};

export const formatNumber = (value: number): string => {
  if (value >= 10000) {
    const w = value / 10000;
    return `${w.toFixed(w >= 10 ? 0 : 1)} 万`;
  }
  return String(value);
};

export const getRelatedArticles = (current: Article, limit = 3): Article[] => {
  const sameCategory = articles.filter(
    (item) => item.id !== current.id && item.categorySlug === current.categorySlug,
  );
  const others = articles.filter(
    (item) => item.id !== current.id && item.categorySlug !== current.categorySlug,
  );
  return [...sameCategory, ...others].slice(0, limit);
};

export const getLatestArticles = (limit = 6): Article[] =>
  [...articles]
    .sort((a, b) => (a.date < b.date ? 1 : -1))
    .slice(0, limit);

export interface TintStyle {
  chipBg: string;
  chipText: string;
  bubble: string;
  soft: string;
  border: string;
  text: string;
  hoverText: string;
}

export const tintMap: Record<"primary" | "accent" | "secondary", TintStyle> = {
  primary: {
    chipBg: "bg-primary-100",
    chipText: "text-primary-800",
    bubble: "bg-primary-500",
    soft: "bg-primary-50",
    border: "border-primary-200",
    text: "text-primary-700",
    hoverText: "group-hover:text-primary-700",
  },
  accent: {
    chipBg: "bg-accent-100",
    chipText: "text-accent-900",
    bubble: "bg-accent-500",
    soft: "bg-accent-50",
    border: "border-accent-200",
    text: "text-accent-800",
    hoverText: "group-hover:text-accent-800",
  },
  secondary: {
    chipBg: "bg-secondary-100",
    chipText: "text-secondary-900",
    bubble: "bg-secondary-500",
    soft: "bg-secondary-50",
    border: "border-secondary-200",
    text: "text-secondary-800",
    hoverText: "group-hover:text-secondary-800",
  },
};